const automations = {
  hubTitle: "Центр автоматизации",
  liveRegistry: "Живой реестр",
  quickActions: "Быстрые действия",
  runOrigamiSync: "Синхронизация Origami",
  openN8n: "Открыть n8n",
  testHealth: "Проверка здоровья",
  sendTestNotification: "Тестовое уведомление",
  running: "Выполняется...",
  actionSuccess: "Успешно",
  actionError: "Ошибка",
  connections: "Подключения",
  online: "Онлайн",
  offline: "Офлайн",
  configured: "Настроено",
  unconfigured: "Не настроено",
  lastChecked: "Последняя проверка",
  testConnection: "Проверить",
  checking: "Проверка...",
  supabase: "Supabase",
  supabaseDesc: "База данных, авторизация и Realtime",
  n8n: "n8n",
  n8nDesc: "Движок рабочих процессов",
  origami: "Origami CRM",
  origamiDesc: "Операционный SOT",
  wati: "WATI WhatsApp",
  watiDesc: "Сообщения клиентам",
  notion: "Notion",
  notionDesc: "Задачи, спецификации и дорожная карта",
  tabEndpoints: "API-эндпоинты",
  tabJobs: "Запланированные задачи",
  tabWebhooks: "Вебхуки",
  tabSuggestions: "Предложения",
  tabRssFeeds: "RSS",
  apiEndpoints: "API-эндпоинты",
  apiEndpointsDesc: "Все активные маршруты в системе",
  method: "Метод",
  path: "Путь",
  auth: "Авторизация",
  authPublic: "Публичный",
  authRequired: "Требуется JWT",
  authAdmin: "Админ",
  tryIt: "Проверить",
  scheduledJobs: "Запланированные задачи",
  scheduledJobsDesc: "pg_cron и n8n workflows",
  pgCronJobs: "Задачи pg_cron",
  jobName: "Имя задачи",
  schedule: "Расписание",
  status: "Статус",
  active: "Активно",
  paused: "Приостановлено",
  runNow: "Запустить",
  n8nWorkflows: "Процессы n8n",
  n8nOpenDashboard: "Открыть панель n8n",
  n8nConfigureUrl: "Настройте URL n8n в environment variables",
  cleanNotifications: "Очистка старых уведомлений",
  cleanNotificationsSchedule: "Ежедневно в полночь",
  weeklyRecurringTasks: "Еженедельные повторяющиеся задачи",
  weeklyRecurringSchedule: "Каждое воскресенье 08:00",
  origamiSync: "Синхронизация Origami",
  origamiSyncSchedule: "Каждый час",
  webhooks: "Входящие вебхуки",
  webhooksDesc: "Эндпоинты для приёма данных от внешних систем",
  source: "Источник",
  purpose: "Назначение",
  copyUrl: "Копировать URL",
  copied: "Скопировано!",
  showPayload: "Показать пример Payload",
  hidePayload: "Скрыть",
  origamiSyncPurpose: "Синхронизация проектов из Origami",
  origamiEntitiesPurpose: "Синхронизация сущностей из Origami",
  pushSubscribePurpose: "Подписка браузера на push-уведомления",
  contractorSubmitPurpose: "Отправка формы нового подрядчика",
  suggestions: "Предложения автоматизации",
  suggestionsDesc: "Что можно автоматизировать — но пока не подключено",
  difficulty: "Сложность",
  impact: "Влияние",
  easy: "Легко",
  medium: "Средне",
  hard: "Сложно",
  high: "Высокое",
  low: "Низкое",
  learnMore: "Подробнее",
  collapse: "Свернуть",
  sug1Title: "Авто-синхронизация Origami по расписанию",
  sug1Desc: "pg_cron вызывает /api/origami/sync каждый час — без n8n",
  sug1Steps: "1. Включите расширение pg_cron\n2. Создайте задачу, вызывающую API route\n3. Убедитесь, что API-ключ настроен",
  sug2Title: "WhatsApp-уведомление при изменении статуса проекта",
  sug2Desc: "DB trigger + WATI API — автоматическое сообщение клиенту",
  sug2Steps: "1. Создайте DB trigger на таблице projects\n2. При изменении статуса → вызов WATI API\n3. Настройте шаблон в панели WATI",
  sug3Title: "Еженедельный отчёт по email",
  sug3Desc: "pg_cron + Edge Function — сводка активности каждое воскресенье",
  sug3Steps: "1. Создайте Edge Function для сбора статистики\n2. Запланируйте через pg_cron каждое воскресенье 08:00\n3. Отправьте через Resend/SendGrid",
  sug4Title: "Авто-создание задач из Notion",
  sug4Desc: "n8n workflow — при добавлении задачи в Notion она создаётся и в системе",
  sug4Steps: "1. Подключите триггер Notion в n8n\n2. Сопоставьте поля с таблицей tasks\n3. Активируйте workflow",
  sug5Title: "Ночное резервное копирование БД",
  sug5Desc: "pg_cron — ежедневный снимок в таблицу бэкапов",
  sug5Steps: "1. Создайте таблицу db_backups\n2. pg_cron задача каждую ночь в 02:00\n3. Сохраняйте метаданные бэкапа",
  sug6Title: "Лог изменений сущностей",
  sug6Desc: "DB trigger — каждое изменение сущности логируется автоматически",
  sug6Steps: "1. Создайте таблицу entity_audit_log\n2. Триггер на INSERT/UPDATE/DELETE\n3. Сохраняйте old_value, new_value, user_id",
  // ─── Activity + Run History tabs ───
  tabActivity: "Активность",
  tabRunHistory: "История запусков",
  // ─── Activity feed ───
  activityFeed: "Лента активности",
  activityFeedDesc: "Последние изменения в системе — в реальном времени",
  activityTable: "Таблица",
  activityAction: "Действие",
  activityRecord: "Запись",
  activityUser: "Пользователь",
  activityTime: "Время",
  activityInsert: "Вставка",
  activityUpdate: "Обновление",
  activityDelete: "Удаление",
  activityNoEntries: "Нет активности",
  activityLive: "Живое",
  // ─── Run history ───
  runHistory: "История запусков",
  runHistoryDesc: "Все ручные и автоматические запуски задач",
  runJobName: "Имя задачи",
  runStatus: "Статус",
  runDuration: "Длительность",
  runTriggeredBy: "Запущено",
  runStarted: "Начало",
  runStatusRunning: "Выполняется",
  runStatusSuccess: "Успешно",
  runStatusError: "Ошибка",
  runNoEntries: "Нет запусков",
  runLive: "Живое",
  runMs: "мс",
  // ─── Cron history ───
  lastRun: "Последний запуск",
  lastRunNever: "Не запускалось",
  lastRunStatus: "Статус последнего запуска",
} as const;
export default automations;
